import { useMutation } from '@tanstack/react-query';
import { DescriptionMutationOptions } from '../../types';
import { luckyCardState } from './luckyCard.requests';
import { LuckyCardStateParams } from './luckyCard.types';

/** Используется для проверки статуса доступности игры lucky card в случаях:
 * - Подтверждения вывода средств
 * - Выхода из игры
 */
export function useGetLuckyCardState(
  options: DescriptionMutationOptions<'', LuckyCardStateParams>
) {
  return useMutation({ mutationFn: luckyCardState, ...options });
}
